import { gql } from "@apollo/client";

export const SIMWB_LOGIN_MUTATION = gql`
  mutation SimwbLogin($email: String!, $password: String!) {
    simwbLogin(email: $email, password: $password) {
      id
      email
      first_name
      last_name
      company
      user_type
      verificationToken
    }
  }
`;

